module.exports = __webpack_public_path__ + "img/20170922055525209.f1d0708f.jpg";